'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Layout = require('./components/Layout.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Layout).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drawer/lib/components/layout/index.js
// module id = 1062
// module chunks = 1